import type { FormState, RegisterReference } from '@/shared/types/users.types';
import type { ColorHelpers } from '@/utils/colorHelpers';

interface Props {
    form: FormState;
    set: <K extends keyof FormState>(k: K, v: FormState[K]) => void;
    reference: RegisterReference;
    c: ColorHelpers;
}

const INPUT = 'w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:border-transparent';

export function StepIdentity({ form, set, reference, c }: Props) {
    return (
        <div className="space-y-5">
            <h2 className="text-xl font-semibold text-gray-900">Zone principale</h2>
            <p className="text-sm text-gray-500">
                Sélectionnez la zone où vous êtes basé(e). Cette information est requise.
            </p>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Zone <span className="text-red-500">*</span>
                </label>
                <select
                    value={form.zoneId}
                    onChange={e => set('zoneId', e.target.value)}
                    className={`${INPUT} ${c.ring}`}
                >
                    <option value="">Sélectionner une zone</option>
                    {reference.zones.map(zone => (
                        <option key={zone.id} value={zone.id}>{zone.name}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}
